<template>
	<v-text-field
		class="body-2"
		:placeholder="placeholder"
		autocomplete="off"
		:hide-details="hideDetails"
		:readonly="readonly"
		:required="required"
		:disabled="disabled"
		:single-line="singleLine"
		:suffix="suffix"
		:prepend-icon="prependIcon"
		:prepend-inner-icon="prependInnerIcon"
		:loading="loading"
		:rules="allRules"
		:solo="solo"
		:filled="filled"
		:flat="flat"
		:outline="outline"
		:name="name"
		:value="value"
		v-on="aOn"
		@paste.prevent="onPaste"
		@input="onInput"
		@change="onChange"
	>
		<template v-slot:prepend-inner>
			<slot name="prepend-inner"></slot>
		</template>
		<template v-slot:prepend>
			<slot name="prepend"></slot>
		</template>
		<template v-slot:append>
			<slot name="append"></slot>
		</template>
		<template v-slot:append-outer>
			<slot name="append-outer"></slot>
		</template>
		<template v-slot:label>
			{{ label }}
			<slot name="label"></slot>
		</template>
	</v-text-field>
</template>

<script>
	import {toNum, toStr} from '../../js/common'

	export default {
		props: {
			label: String,
			placeholder: String,
			value: [String, Number],
			readonly: Boolean,
			disabled: Boolean,
			required: Boolean,
			loading: Boolean,
			solo: Boolean,
			filled: Boolean,
			outline: Boolean,
			flat: Boolean,
			hideDetails: {
				type: Boolean,
				default: true
			},
			suffix: String,
			prependIcon: String,
			prependInnerIcon: String,
			singleLine: Boolean,
			name: String,
			align: String,
			rules: Array,
			aOn: Object,
		},
		computed: {
			allRules() {
				const rules = this.rules || []

				if (this.required) {
					var rule =
						v => !!v || 'Обязательное поле'

					rules.push(rule)
				}

				// console.log(rules)

				return rules
			},
		},
		data: () => ({
		}),
		methods: {
			onPaste: function (event) {
				// console.log('onPaste')
				let val = event.clipboardData.getData('text')
				val = val.trim()
				let delimeter = '\n'
				let arr = val.split(delimeter)
				// for (let i = 0; i < arr.length; i++) {
				// 	arr[i] = this.format(arr[i])
				// }
				// console.log('arr', arr)
				val = arr.shift()
				// console.log('val', val)
				// console.log('arr', arr)
				this.$emit('input', val)
				if (arr.length) this.$emit('newline', arr.join(delimeter))
			},
			onInput: function (val) {
				// console.log('onInput')
				// console.log('val', val)
				this.$emit('input', val)
			},
			onChange: function(e) {
				// console.log('onChange')
				// e = this.format(e)
				this.$emit('input', e)
				this.$emit('change', e)
			},
		}
	}
</script>

<style scoped>
	.v-text-field {
		padding-top: 0px;
		margin-top: 0px;
	}
	/deep/ .v-input__slot {
		margin-bottom: 0px;
	}
	/deep/ .v-text-field__slot > input {
		text-align: center;
		padding-bottom: 4px;
	}
	/deep/ .v-text-field__details > .v-messages {
		min-height: 0px;
	}
</style>
